export const DEFAULT_NODE_SETTINGS = {
    takePlace: true,
    webAr: { visible: true },
};
export function deepMerge(target, source) {
    const result = {};
    const src = source;
    for (const key of Object.keys(target)) {
        const targetValue = target[key];
        if (typeof targetValue === 'object' && targetValue !== null && !Array.isArray(targetValue)) {
            result[key] = deepMerge(targetValue, {});
        }
        else {
            result[key] = targetValue;
        }
    }
    for (const key of Object.keys(src)) {
        const sourceValue = src[key];
        const targetValue = target[key];
        if (sourceValue === undefined) {
            continue;
        }
        if (typeof sourceValue === 'object' &&
            sourceValue !== null &&
            !Array.isArray(sourceValue) &&
            typeof targetValue === 'object' &&
            targetValue !== null) {
            result[key] = deepMerge(targetValue, sourceValue);
        }
        else {
            result[key] = sourceValue;
        }
    }
    return result;
}
export function resolveNodeSettings(settings) {
    return deepMerge(DEFAULT_NODE_SETTINGS, settings !== null && settings !== void 0 ? settings : {});
}
//# sourceMappingURL=NodeSettings.js.map